import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-226e4851"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center mb-8" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Ayarlar"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-2" })
], -1))
const _hoisted_2 = {
  key: 0,
  class: "flex items-center space-x-4"
}
const _hoisted_3 = { class: "flex flex-col gap-4 h-screen w-full" }
const _hoisted_4 = { class: "p-4 bg-white rounded-md shadow" }
const _hoisted_5 = { class: "pb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold pb-4" }, "Şifre Değiştir", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Mevcut Şifreniz", -1))
const _hoisted_8 = ["type"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Yeni Şifreniz", -1))
const _hoisted_10 = ["type"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700" }, "Yeni Şifreniz (Tekrar)", -1))
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = { class: "mb-4 flex items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "show-passwords",
  class: "text-gray-700"
}, "Şifreleri göster", -1))
const _hoisted_16 = { class: "p-4 bg-white rounded-md shadow" }
const _hoisted_17 = { class: "pb-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold pb-4" }, "ScoolMeet.Ai Veli Görüşme Adresi", -1))
const _hoisted_19 = {
  href: "https://schoolmeet.ai/meet/x-okullari",
  target: "_blank",
  class: "text-indigo-600"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current h-4 w-4 text-gray-600",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!_ctx.Loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwords.initialPassword) = $event)),
                  type: _ctx.allPasswordsVisible ? 'text' : 'password',
                  placeholder: "Mevcut Şifreniz",
                  class: "block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 focus:outline-none focus:bg-white focus:border-gray-500"
                }, null, 8, _hoisted_8), [
                  [_vModelDynamic, _ctx.passwords.initialPassword]
                ]),
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  rows: "4",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwords.newPassword) = $event)),
                  type: _ctx.allPasswordsVisible ? 'text' : 'password',
                  placeholder: "Yeni Şifreniz",
                  class: "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                }, null, 8, _hoisted_10), [
                  [_vModelDynamic, _ctx.passwords.newPassword]
                ]),
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  rows: "4",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwords.newPasswordAgain) = $event)),
                  type: _ctx.allPasswordsVisible ? 'text' : 'password',
                  placeholder: "Mevcut Şifreniz (Tekrar)",
                  class: "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                }, null, 8, _hoisted_12), [
                  [_vModelDynamic, _ctx.passwords.newPasswordAgain]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      id: "show-passwords",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.allPasswordsVisible) = $event)),
                      class: "mr-2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.allPasswordsVisible]
                    ]),
                    _hoisted_15
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateUserPassword && _ctx.updateUserPassword(...args))),
                    class: "rounded-md bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  }, " Güncelle ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.School.slug), 1),
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                  class: "px-6 py-2.5 ml-8"
                }, _hoisted_21)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}